// extracted by mini-css-extract-plugin
module.exports = {"ParentLoading":"style_ParentLoading__3FbaI","loading":"style_loading__3Eq6g","load":"style_load__aMJa3"};